<template>
    <div>
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10 '/>
        <BreadCrumbsComponent :breadcrumbs="breadcrumbs" class="margin-breadcrumb mt-180"/>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 mb-16 pb-md-16">
            <h1 class="font-size-custom font-weight-bold orange--text font-title"><i>APLICACIONES</i></h1>
            <p class='gray--text mt-14 font-text'>
                En virtud de asegurar su comodidad, lo invitamos a concurrir a nuestros <a href="#">centros de aplicaciones</a>, donde
                <br/>
                podrá recibir la administración de terapias biológicas, hierros, antibióticos, vitaminas e hidrataciones
                <br/>
                o bien la medicina que necesite. Recuerde que también realizamos <b>aplicaciones a domicilio</b>
            </p>
            <v-row>
                <v-col cols="12" md=7 class='mt-md-14'>
                    <v-img :src="`${require('@/assets/aplicaciones-foto1.png')}`" contain class='rounded-xl' />
                    <div class='primary mt-md-10 mt-5 rounded-xl'> 
                        <v-row
                            align="center"
                            justify="center"
                        >
                            <v-col cols="12"  sm='3' class='text-center'>    
                                <img :src="require('@/assets/logo-envíos-aplicaciones.png')" style="width: 140px">
                            </v-col>
                            <v-col 
                                cols="12" sm='8' 
                                class='white--text py-md-10 px-10 pl-sm-10 px-md-0 pr-md-10 text-md-h5' 
                                style="line-height:1">
                                <b><i>Puede realizarse aplicaciones en su domicilio.<br />
                                Solicite un turno en nuestras líneas telefónicas.</i></b>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col cols="12" md='5' class='mt-md-14'>
                    <v-col class='orange rounded-xl white--text py-10 px-10 font-text'> 
                        <h3><i>Para solicitar un turno comuníquese
                        <br />con nosotros a los siguientes números:</i></h3>
                        <p></p>
                        <b><h1><i>Llámenos al (02) 5 100 700.</i></h1></b>
                        <h1 style="font-weight:500">099 134 2224</h1>
                    </v-col>
                    <v-img :src="`${require('@/assets/Covid-19.jpg')}`" contain class='rounded-xl mt-md-10 mt-5' />
                </v-col>
            </v-row>
        </div>
        <FooterComponent />
    </div>
</template>

<script>

import MenuMovilComponent from '../partials/MenuMovilComponent'
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'

export default {
    name:'DrugCatalogsComponent',
    components:{
        MenuMovilComponent,
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
    },
    data:()=>({
       breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Aplicaciones',url:'/aplicaciones'}
        ],
    }),
    computed:{

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

    },
    created(){
        this.$emit('newBreadcrumbs',this.breadcrumbs)
    }
}
</script>

<style>
    div .primary{
        background: linear-gradient(180deg, rgba(80,201,149,1) 0%, rgba(109,207,165,1) 100%);
    }

    div .orange{
        background: linear-gradient(0deg, rgba(255,148,20,1) 33%, rgba(255,165,57,1) 100%);
    }

    .v-application .text-md-h5{
        font-family: Asap!important
    }
</style>